/*
 * Model for getting monetary unit data
 */
angular.module('taric.model.er', ['common.helper', 'ngResource', 'common.config'])
    .factory('ExchangeRates', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/moun/er/exchangerates', {}, {
        queryMonetaryExchangePeriodWithRateDirection: {
            method: 'GET',
            isArray: false
        },
        exchangeMoneyForGUI: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/moun/er/calculateexchangerate'
        }
    });
}).service('ExchangeRatesModel', function ($q, ExchangeRates, CommonHelper, $translate, CONSTANTS) {
    var model = this;

    var searchCriteria = {},
        calculateCriteria = {},
        calculateExchangeRateResult = {};

    model.customsValueMonetaryUnits = {count: 0, items: []};

    var searchExchangesRateInput = {
        currency: CONSTANTS.installationCurrency,
        fromDate: new Date(),
        toDate: null,
        language: CommonHelper.getLanguageCode($translate.use())
    };

    model.getSearchExchangeRatesInput = function () {
        return searchExchangesRateInput;
    };

    model.getCalculateExchangeRateResult = function () {
        return calculateExchangeRateResult;
    };

    model.resetCalculateResult = function () {
        calculateExchangeRateResult = {};
        calculateExchangeRateResult.amount = '0';
        calculateExchangeRateResult.amountEUR = '0';
    };

    model.getSearchCriteria = function (){
        return searchCriteria;
    };

    model.getCalculateCriteria = function (){
        return calculateCriteria;
    };

    model.resetSearchCriteria = function () {
        // Set the default search criteria when the model is initialized
        searchCriteria = {};
        searchCriteria.fromDate = new Date();
        searchCriteria.toDate = null;
        searchCriteria.language = CommonHelper.getLanguageCode($translate.use());
        searchCriteria.ascending = true;
    };

    model.resetCalculateCriteria = function () {
        // Set the default calculate criteria when the model is initialized
        calculateCriteria = {};
        calculateCriteria.amount = '0';
        calculateCriteria.exchangeDate = new Date();
        calculateCriteria.fromCurrency = CONSTANTS.installationCurrency;
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetCalculateCriteria();
        model.resetCalculateResult();
    };

    model.reset();

    model.queryMonetaryExchangePeriodWithRateDirection = function (pageNumber) {
        var deferred = $q.defer();

        var options = {
            currency: CommonHelper.removeSpaceCharacters(searchCriteria.monetaryUnit),
            fromDate: CommonHelper.getRestDateString(searchCriteria.fromDate),
            toDate: CommonHelper.getRestDateString(searchCriteria.toDate),
            language: CommonHelper.getLanguageCode($translate.use()),
            sortorder: searchCriteria.ascending ? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol
        };
        
        if (pageNumber) {
            options.offset =  CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = ExchangeRates.queryMonetaryExchangePeriodWithRateDirection(options, function () {
            var searchExchangeRatesResult = {};
            searchExchangeRatesResult.totalItems = result.count;
            searchExchangeRatesResult.monetaryExchangePeriods = result.items;

            if (pageNumber) {
                searchExchangeRatesResult.currentPage= pageNumber;
            }

            deferred.resolve(searchExchangeRatesResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.calculateExchangeRate = function () {
        var deferred = $q.defer();

        var options = {
            amount: CommonHelper.getDecimalNumber(calculateCriteria.amount),
            fromCurrency: CommonHelper.removeSpaceCharacters(calculateCriteria.fromCurrency),
            exchangeDate: CommonHelper.getRestDateString(calculateCriteria.exchangeDate)
        };

        var result = ExchangeRates.exchangeMoneyForGUI(options, function () {
            calculateExchangeRateResult = {};
            calculateExchangeRateResult.amount = result.amount;
            calculateExchangeRateResult.amountEUR = result.amountEUR;
            deferred.resolve(calculateExchangeRateResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

});



// WEBPACK FOOTER //
// ./app/taric/duties/shared/exchange-rates-model.js